import { render, staticRenderFns } from "./regimeDom.vue?vue&type=template&id=23b3962c&scoped=true&"
import script from "./regimeDom.vue?vue&type=script&lang=js&"
export * from "./regimeDom.vue?vue&type=script&lang=js&"
import style0 from "./regimeDom.vue?vue&type=style&index=0&id=23b3962c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3962c",
  null
  
)

export default component.exports